var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComprasInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6 21.3c-.3-2.2-1-10.8 4.6-11.7 1.7-.3 3.1.3 4.2 1.4.8-1.5 2-2.4 3.5-2.7 2.6-.4 4.9 1.2 6.5 4.8.9 2 1.4 4 1.5 4.9l5.8-.9.9-.1.2.9L61 56.3l.3 1-1.1.2L31 62.2h-.1l-.8.1h-.2l-9.6 1.6-1.1.2-.1-1.1-2.4-39.5-.1-.9.9-.1 7.1-1.2zm.6 38-3.7 3.5 7.7-1.2-4-2.3zm4.8 1.5-4.4-2.4-1.9-36 3.9-.6 2.4 39zm-.7-50.2c-4.6.7-4 8.5-3.8 10.6l1.9-.3h.1l.8-.1h.2l3.8-.6c-.1-.9-.3-3-.1-5.1.1-1.1.4-2.1.7-3-.9-1.1-2.1-1.7-3.6-1.5zm6.9 8.8-2.9.5-.01-.11c-.107-1.278-.367-4.366.41-6.89 1.406 2.062 2.109 4.915 2.438 6.253l.062.247zm6.3-5.8c-1.4-3.2-3.3-4.6-5.4-4.2-1.5.2-2.4 1.2-3 2.5 1.9 2.4 2.8 6.1 3.1 7.5l6.8-1.2c-.2-.9-.7-2.8-1.5-4.6zm8.5 4.5 9.2 38.4L31 61.2l-2.3-39.4v-.1L51 18.1zM20.3 62.5l4.3-4-1.9-35.8-4.8.8 2.4 39zm-5.1-40.6-4-3c-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1l4 3c.2.2.3.5.1.7-.1.1-.2.2-.4.2-.1 0-.2 0-.3-.1zm3.8-2.4v-5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v5c0 .3.2.5.5.5s.5-.2.5-.5zM10.5 27c-.2 0-.4-.2-.5-.4-.1-.2.1-.5.4-.6l4-1c.3 0 .5.1.6.4 0 .3-.1.5-.4.6l-4 1h-.1z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1 38.4c-.5-4.2 2.4-8.2 6.7-8.9 4.4-.8 8.7 2.2 9.5 6.6.8 4.4-2.2 8.7-6.6 9.5-4.3.8-8.4-2-9.3-6.2l-.3-1zm.9-.2 2.4-.4c-.4-2.9.8-5.4 1.8-6.8-2.7 1.2-4.5 4.1-4.2 7.2zm7.4-1.2-1.1-6c1.3.8 3.5 2.7 4.1 5.5l-3 .5zm.2.9 1 6c.9-1.3 2.2-3.7 2-6.5l-3 .5zm-4 .7 3-.5 1.1 5.9c-1.3-.9-3.4-2.7-4.1-5.4zm2.8-1.5-1.1-6c-.9 1.2-2.3 3.7-2 6.5l3.1-.5zm5-.8c-.6-2.9-2.7-4.9-4.1-5.9 3.2 0 6 2.2 6.8 5.4l-2.7.5zm2.9.5-2.7.5c.3 3-1 5.6-2 7 3.1-1.2 5-4.2 4.7-7.5zm-11.7 2c.7 2.9 2.8 4.8 4.2 5.9-3.1-.2-5.8-2.4-6.6-5.5l2.4-.4z",
    fill: "#09C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComprasInternet);
export default __webpack_public_path__ + "static/media/icon_compras_internet.3bc83589.svg";
export { ForwardRef as ReactComponent };